import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';
import { TenantDatabaseConnectionConfig } from './tenant-database-connection-config';

export class TenantConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string | undefined;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	version?: string | undefined;
	objectState?: ObjectState | undefined;
	useCustomConnection?: boolean | undefined;
	customConnection?: TenantDatabaseConnectionConfig;
	relatedUserIds: string[] = [];

	constructor(init?: Partial<TenantConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
